// extracted by mini-css-extract-plugin
export default {"overlay":"AP-z","bodyOpen":"BP-z","content":"CP-z","header":"DP-z","close":"EP-z","closeNoHeading":"FP-z"};